module.exports = undefined;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"lodash","commonjs2":"lodash","amd":"_","root":"_"}
// module id = 2
// module chunks = 0 1 2